import { useMemo, useState } from "react"
import logo from "./logo.png"

const questions = [
    {
        id: "discordName",
        label: "Discord nick",
        type: "text",
        required: true,
        placeholder: "Alex",
        ic: false
    },
    {
        id: "realAge",
        label: "Věk",
        type: "number",
        required: true,
        placeholder: "18",
        ic: false
    },
    {
        id: "timezoneActivity",
        label: "Kdy se nejčastěji pohybuješ na serveru",
        type: "textarea",
        required: true,
        placeholder: "Dny v týdnu, přibližné časy.",
        ic: false
    },
    {
        id: "rpExperience",
        label: "Zkušenosti s RP",
        type: "textarea",
        required: true,
        placeholder: "Jak dlouho hraješ RP, případně na jakých serverech.",
        ic: false
    },

    {
        id: "icName",
        label: "Jméno postavy",
        type: "text",
        required: true,
        placeholder: "John Carter",
        ic: true
    },
    {
        id: "icAge",
        label: "Věk postavy",
        type: "number",
        required: true,
        placeholder: "25",
        ic: true
    },
    {
        id: "icMotivation",
        label: "Motivace vstoupit k SSFD",
        type: "textarea",
        required: true,
        placeholder: "Proč se rozhoduješ stát hasičem.",
        ic: true
    },

    {
        id: "icPersonalGear",
        label: "Které z těchto věcí patří k osobní výstroji hasiče",
        type: "checkbox",
        required: false,
        options: [
            "Zásahový oblek",
            "Helma",
            "Rukavice",
            "Dýchací technika",
            "Termokamera",
            "Balistická vesta"
        ],
        ic: true
    },
    {
        id: "icVehicleGear",
        label: "Co bys očekával na hasičském vozidle",
        type: "checkbox",
        required: false,
        options: [
            "Hadice",
            "Proudnice",
            "Hydraulické nůžky / rozpínák",
            "Kužely",
            "Zdravotnické vybavení",
            "Služební pistole"
        ],
        ic: true
    },
    {
        id: "icIncidents",
        label: "Jaké typy zásahů hasiči běžně řeší",
        type: "checkbox",
        required: false,
        options: [
            "Požáry",
            "Dopravní nehody",
            "Technické zásahy",
            "Úniky nebezpečných látek",
            "Ozbrojené přepadení"
        ],
        ic: true
    },
    {
        id: "icFirstSteps",
        label: "Co se obvykle řeší jako první po příjezdu jednotky k zásahu",
        type: "text",
        required: false,
        placeholder: "Jedna krátká věta nebo pár slov.",
        ic: true
    },
    {
        id: "icCooperation",
        label: "S jakými složkami hasiči při zásazích spolupracují",
        type: "checkbox",
        required: false,
        options: [
            "Policie",
            "Zdravotnická záchranná služba",
            "Sheriff",
            "Armáda",
            "Park Rangers",
            "FIB"
        ],
        ic: true
    }
]

function Logo() {
    return (
        <div className="flex items-center gap-4">
            <img
                src={logo}
                alt="SSFD"
                className="h-14 w-14 object-contain drop-shadow"
            />
            <div className="leading-tight">
                <div className="text-sm text-zinc-400 uppercase tracking-widest">
                    Sandy Shores Fire Department
                </div>
                <div className="text-2xl font-extrabold tracking-wide">
                    <span className="text-red-500">SSFD</span>{" "}
                    <span className="text-amber-300">RECRUITMENT</span>
                </div>
            </div>
        </div>
    )
}

function InputBase({ children }) {
    return (
        <div className="rounded-xl bg-zinc-950/60 border border-zinc-800 focus-within:border-red-500/60 focus-within:ring-2 focus-within:ring-red-500/20 transition">
            {children}
        </div>
    )
}

function TextInput({ value, onChange, placeholder, type = "text" }) {
    return (
        <InputBase>
            <input
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className="w-full bg-transparent px-4 py-3 outline-none text-white placeholder:text-zinc-600"
            />
        </InputBase>
    )
}

function TextArea({ value, onChange, placeholder }) {
    return (
        <InputBase>
            <textarea
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className="w-full min-h-[110px] resize-y bg-transparent px-4 py-3 outline-none text-white placeholder:text-zinc-600"
            />
        </InputBase>
    )
}

function TypeBadge({ ic }) {
    return (
        <span
            className={[
                "inline-flex items-center rounded-full px-2 py-1 text-[10px] font-extrabold tracking-widest border",
                ic
                    ? "bg-red-500/15 text-red-300 border-red-500/30"
                    : "bg-sky-500/15 text-sky-300 border-sky-500/30"
            ].join(" ")}
        >
            {ic ? "IC" : "OOC"}
        </span>
    )
}

function CheckboxGroup({ value, onChange, options }) {
    const selected = Array.isArray(value) ? value : []

    function toggle(opt) {
        const next = selected.includes(opt)
            ? selected.filter((x) => x !== opt)
            : [...selected, opt]
        onChange(next)
    }

    return (
        <div className="rounded-2xl border border-zinc-800 bg-zinc-950/40 p-3">
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                {options.map((opt) => {
                    const on = selected.includes(opt)
                    return (
                        <button
                            key={opt}
                            type="button"
                            onClick={() => toggle(opt)}
                            className={[
                                "group flex items-center justify-between rounded-xl border px-4 py-3 text-left transition",
                                on
                                    ? "border-red-500/50 bg-red-500/10"
                                    : "border-zinc-800 bg-zinc-950/40 hover:border-zinc-700"
                            ].join(" ")}
                        >
                            <span className={["text-sm font-semibold", on ? "text-red-100" : "text-zinc-200"].join(" ")}>
                                {opt}
                            </span>

                            <span
                                className={[
                                    "ml-3 inline-flex h-6 min-w-[64px] items-center justify-center rounded-full border text-[11px] font-extrabold tracking-widest transition",
                                    on
                                        ? "border-red-500/40 bg-red-500/20 text-red-200"
                                        : "border-zinc-800 bg-zinc-950/60 text-zinc-400 group-hover:text-zinc-300"
                                ].join(" ")}
                            >
                                {on ? "VYBRÁNO" : "VYBRAT"}
                            </span>
                        </button>
                    )
                })}
            </div>

            {selected.length > 0 && (
                <div className="mt-3 flex flex-wrap gap-2">
                    {selected.map((s) => (
                        <span
                            key={s}
                            className="inline-flex items-center rounded-full border border-red-500/30 bg-red-500/10 px-3 py-1 text-xs font-semibold text-red-200"
                        >
                            {s}
                        </span>
                    ))}
                </div>
            )}
        </div>
    )
}

const API_URL = "https://ssfd.lexikonn.eu/api/submit.php"

export default function App() {
    const initial = useMemo(() => {
        const o = {}
        for (const q of questions) {
            if (q.type === "checkbox") o[q.id] = []
            else o[q.id] = ""
        }
        o.agree = false
        return o
    }, [])

    const [form, setForm] = useState(initial)
    const [sending, setSending] = useState(false)
    const [status, setStatus] = useState(null)

    const requiredMissing = useMemo(() => {
        for (const q of questions) {
            if (!q.required) continue
            if (q.type === "checkbox") {
                const arr = Array.isArray(form[q.id]) ? form[q.id] : []
                if (arr.length === 0) return true
            } else {
                if (!String(form[q.id] || "").trim()) return true
            }
        }
        if (!form.agree) return true
        return false
    }, [form])

    function setVal(id, v) {
        setForm((p) => ({ ...p, [id]: v }))
    }

    async function submit(e) {
        e.preventDefault()
        if (requiredMissing || sending) return

        setSending(true)
        setStatus(null)

        try {
            const r = await fetch(API_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json; charset=utf-8" },
                body: JSON.stringify(form)
            })

            const j = await r.json().catch(() => null)

            if (!r.ok || !j || !j.ok) {
                const msg = (j && (j.error || j.detail)) ? String(j.error || j.detail) : "ODESLÁNÍ_SE_NEPOVEDLO"
                setStatus({ ok: false, msg })
                setSending(false)
                return
            }

            setStatus({ ok: true, msg: "Přihláška odeslaná na Discord." })
            setForm(initial)
        } catch (err) {
            setStatus({ ok: false, msg: "CHYBA_PŘIPOJENÍ" })
        } finally {
            setSending(false)
        }
    }

    return (
        <div className="min-h-screen bg-zinc-950 text-white">
            <div className="mx-auto max-w-3xl px-5 py-10">
                <div className="rounded-3xl border border-zinc-800 bg-gradient-to-b from-zinc-900/70 to-zinc-950 p-6 shadow-2xl shadow-black/40">
                    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                        <Logo />
                    </div>

                    <form onSubmit={submit} className="mt-6 space-y-5">
                        <div className="grid grid-cols-1 gap-4">
                            {questions.map((q) => (
                                <div key={q.id} className="space-y-2">
                                    <div className="flex items-center justify-between gap-3">
                                        <div className="flex items-center gap-2">
                                            <label className="text-sm font-semibold text-zinc-200">
                                                {q.label}
                                            </label>
                                            <TypeBadge ic={q.ic} />
                                        </div>

                                        <div className="flex items-center gap-2">
                                            {q.required && (
                                                <span className="text-xs text-red-300">povinné</span>
                                            )}
                                        </div>
                                    </div>

                                    {q.type === "checkbox" ? (
                                        <CheckboxGroup
                                            value={form[q.id]}
                                            options={q.options || []}
                                            onChange={(next) => setVal(q.id, next)}
                                        />
                                    ) : q.type === "textarea" ? (
                                        <TextArea
                                            value={form[q.id]}
                                            onChange={(e) => setVal(q.id, e.target.value)}
                                            placeholder={q.placeholder}
                                        />
                                    ) : (
                                        <TextInput
                                            type={q.type}
                                            value={form[q.id]}
                                            onChange={(e) => setVal(q.id, e.target.value)}
                                            placeholder={q.placeholder}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>

                        <label className="flex items-center gap-3 rounded-2xl border border-zinc-800 bg-zinc-950/40 px-4 py-3">
                            <input
                                type="checkbox"
                                checked={form.agree}
                                onChange={(e) => setVal("agree", e.target.checked)}
                                className="h-5 w-5 accent-red-500"
                            />
                            <div className="text-sm text-zinc-300">
                                Souhlasím s odesláním přihlášky na SSFD Discord.
                            </div>
                        </label>

                        {status && (
                            <div
                                className={[
                                    "rounded-2xl border px-4 py-3 text-sm font-semibold",
                                    status.ok
                                        ? "border-emerald-500/30 bg-emerald-500/10 text-emerald-200"
                                        : "border-red-500/30 bg-red-500/10 text-red-200"
                                ].join(" ")}
                            >
                                {status.msg}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={requiredMissing || sending}
                            className="w-full rounded-2xl bg-gradient-to-r from-red-500 to-amber-300 text-zinc-950 font-extrabold tracking-wide py-3 disabled:opacity-40 transition"
                        >
                            {sending ? "ODESÍLÁM..." : "ODESLAT PŘIHLÁŠKU"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    )
}
